module.exports = __webpack_public_path__ + "static/media/invention.cd13ce04.svg";